module.exports = __webpack_public_path__ + "static/media/incorrect_ic.64aaa5d2.svg";